/** @jsx jsx */
/** @jsxFrag */
import { ClassNames, jsx } from '@emotion/react';
import DownloadIcon from 'icons/DownloadIcon';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Attachment } from 'types/Attachment';

export interface ArticleDownloadProps extends React.HTMLAttributes<HTMLDivElement> {
  attachments: Attachment[];
}

const ArticleDownload: React.FC<ArticleDownloadProps> = ({ attachments = [] }) => {
  return (
    <ClassNames>
      {({ theme }) => (
        <div
          css={{
            '@media(min-width: 600px)': { minWidth: 200 },
            '@media(min-width: 960px)': { minWidth: 300 },
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h2 css={{ ...theme.typography.h2, marginBottom: theme.spacing(2) }}>
            <FormattedMessage id={'btn.download'} />
          </h2>
          <div css={{ display: 'flex', flexDirection: 'column' }}>
            {attachments.map((i, idx) => (
              <ArticleDownloadItem key={idx.toString()} {...i} />
            ))}
          </div>
        </div>
      )}
    </ClassNames>
  );
};

export default ArticleDownload;

const ArticleDownloadItem: React.FC<Attachment> = ({ title, href }) => {
  return (
    <ClassNames>
      {({ theme }) => (
        <a
          href={href}
          css={{
            '&:hover': {
              background: theme.palette.divider,
            },
            '&:not(:last-of-type)': {
              borderBottom: '1px solid',
              borderBottomColor: theme.palette.divider,
            },
            alignItems: 'center',
            color: theme.palette.text.primary,
            cursor: 'pointer',
            display: 'flex',
            fontWeight: theme.typography.fontWeightMedium,
            padding: theme.spacing(1),
            textDecoration: 'none',
            transition: 'all .2s ease',
          }}
        >
          <DownloadIcon css={{ marginRight: theme.spacing(2) }} />
          {title}
        </a>
      )}
    </ClassNames>
  );
};
